var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic:round-search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-90.000000, -47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic:round-search",
    transform: "translate(90.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0.9375,
    y: 0.9375,
    width: 14.0625,
    height: 14.0625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9990304,9.67363026 L10.3039746,9.67363026 L10.0576258,9.43621882 C11.1709099,8.14362179 11.6484332,6.42167599 11.3597555,4.74074802 C10.9462413,2.29628943 8.90506497,0.344239774 6.44157626,0.0452772139 C4.68644954,-0.176633358 2.92729111,0.425133726 1.6763371,1.67535443 C0.425383086,2.92557513 -0.176736962,4.68370234 0.045303771,6.4378002 C0.344441686,8.89984481 2.29763631,10.9398246 4.74352868,11.3530964 C6.42544259,11.6416049 8.14839839,11.1643615 9.44175359,10.05173 L9.67930428,10.2979344 L9.67930428,10.9925827 L13.4185282,14.7296147 C13.7792534,15.0901284 14.368731,15.0901284 14.7294561,14.7296147 C15.0901813,14.3691011 15.0901813,13.779969 14.7294561,13.4194553 L10.9990304,9.67363026 Z M5.72012599,9.67363026 C3.52938067,9.67363026 1.7609477,7.90623395 1.7609477,5.71677285 C1.7609477,3.52731174 3.52938067,1.75991543 5.72012599,1.75991543 C7.91087131,1.75991543 9.67930428,3.52731174 9.67930428,5.71677285 C9.67930428,7.90623395 7.91087131,9.67363026 5.72012599,9.67363026 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b3984915.svg";
export { ForwardRef as ReactComponent };